module.exports = {"410671400":"东杨","410671401":"渤海路","410671402":"海河路"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410671.json
// module id = 1581
// module chunks = 0